<template>
  <div class="c-enter">

    <div class="c-inari c-enter__inari" v-bind:class="{'c-inari--active': stage === 6}">
      <img :src="`${baseUrl}img/inari.svg`" alt="INARI">
    </div>

    <div class="c-enter__airasia">
      <a href="https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en" target="_blank" @click="$ga.event('SecretScrolls', 'Click', 'AirAsia Small Entry Logo');">
        <img :src="`${baseUrl}img/airasia.svg`" alt="AirAsia">
      </a>
    </div>

    <div class="c-scroll c-scroll--large c-enter">
      <img class="c-scroll__top" :src="`${baseUrl}img/scroll/top.svg`" alt="">
      <div class="c-scroll__middle">
        <svg class="c-scroll__shadow c-scroll__shadow--top" width="532.4" height="81.16" preserveAspectRatio="xMinYMin meet" viewBox="0 0 532.4 81.16" role="presentation"><path fill="#cfa973" d="M532.4 0v43.72L0 81.16V0z"/></svg>

        <div class="c-enter__content">
          <header>
            <h3>You did it!</h3>
            <p>Submit your entry now for a chance to <span>WIN 2x return flights to Japan</span></p>
          </header>

          <form class="c-form">
            <div class="c-input-field" v-bind:class="{'c-form-error': fnameError}">
              <input type="text" name="name" id="name" v-model="formData.firstName" placeholder="First name" @focus="$ga.event('SecretScrolls', 'Click', 'First Name');">
              <small class="c-error-message">Please enter your first name</small>
            </div>

            <div class="c-input-field" v-bind:class="{'c-form-error': lnameError}">
              <input type="text" name="name" id="name" v-model="formData.lastName" placeholder="Last name" @focus="$ga.event('SecretScrolls', 'Click', 'Last Name');">
              <small class="c-error-message">Please enter your last name</small>
            </div>

            <div class="c-input-field" v-bind:class="{'c-form-error': emailError}">
              <input type="email" name="email" id="email" v-model="formData.email" placeholder="Email address" @focus="$ga.event('SecretScrolls', 'Click', 'Email Address');">
              <small class="c-error-message">Please enter a valid personal email address</small>
            </div>

            <div class="c-input-field" v-bind:class="{'c-form-error': postcodeError}">
              <input type="number" name="postcode" id="postcode" v-model="formData.postcode" min="0" max="9999" placeholder="Postcode" @focus="$ga.event('SecretScrolls', 'Click', 'Post code');">
              <small class="c-error-message">Please enter a valid postcode within Australia</small>
            </div>

            <div class="c-input-field c-input-field--padtop c-checkbox" v-bind:class="{'c-form-error': termsError}">
              <input type="checkbox" name="terms" id="terms" value="Agree" v-model="formData.termsConditions" @click="$ga.event('SecretScrolls', 'Click', 'Terms');">
              <label for="terms">I agree to the <a href="https://www.jnto.org.au/app/uploads/2018/06/JNTO_Scrolls_Of_Ikigai_Terms_Conditions_May_24th.pdf" target="_blank">Terms &amp; Conditions</a> and <a href="https://www.airasia.com/my/en/about-us/privacy-policy.page" target="_blank">AirAsia's privacy policy</a></label>
              <small class="c-error-message">Please confirm the above.</small>
            </div>

            <div class="c-input-field c-checkbox">
              <input type="checkbox" name="subscribe" id="subscribe" value="Agree" v-model="formData.optinSubscription" @click="$ga.event('SecretScrolls', 'Click', 'Newsletter');">
              <label for="subscribe">Yes, I’d like to subscribe to the AirAsia newsletter to receive updates about travel news, deals and offers.</label>
            </div>

            <div class="c-enter__submit">
              <button type="submit" class="c-button c-button--primary c-button--small" v-bind:class="{'c-button--loading': loading}" @click.prevent="submitEnter">OPEN THE SECRET SCROLL TO IKIGAI</button>
            </div>
          </form>

        </div>

        <svg class="c-scroll__shadow c-scroll__shadow--bottom" width="532.4" height="81.28" preserveAspectRatio="xMinYMax meet" viewBox="0 0 532.4 81.28" role="presentation"><path fill="#cfa973" d="M0 12.28L532.4 0v81.28H0z"/></svg>
      </div>
      <img class="c-scroll__bottom" :src="`${baseUrl}img/scroll/bottom.svg`" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'entry-form',
  data() {
    return {
      formData: {
        campaign: '5af37c17932ea21d170eb88d',
        firstName: null,
        lastName: null,
        email: null,
        postcode: null,
        termsConditions: false,
        optinSubscription: false,
        passcode: 'inari',
        utm_source: 'source',
        utm_campaign: '',
        utm_medium: '',
      },
      success: false,
      fnameError: false,
      lnameError: false,
      emailError: false,
      postcodeError: false,
      termsError: false,
      loading: false,
    };
  },
  computed: {
    stage: {
      get() { return this.$store.state.stage; },
      set(value) { this.$store.commit('setStage', value); },
    },
  },
  methods: {
    validateEmail(email) {
      const re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return re.test(email);
    },
    validateText(value) {
      if (value === null || value === '') return false;
      return true;
    },
    validatePostcode(value) {
      if (value === null || value === '' || value.length !== 4 || parseInt(value, 10) > 9999) return false;
      return true;
    },
    validateForm() {
      // check fname
      if (!this.validateText(this.formData.firstName)) this.fnameError = true;
      else this.fnameError = false;

      // check lname
      if (!this.validateText(this.formData.lastName)) this.lnameError = true;
      else this.lnameError = false;

      // validate email
      if (!this.validateEmail(this.formData.email)) this.emailError = true;
      else this.emailError = false;

      // check postcode
      if (!this.validatePostcode(this.formData.postcode)) this.postcodeError = true;
      else this.postcodeError = false;

      // check terms
      this.termsError = !this.formData.termsConditions;

      // check for any errors
      if (this.fnameError
        || this.lnameError
        || this.emailError
        || this.postcodeError
        || this.termsError) {
        return false;
      }

      // success
      return true;
    },
    submitEnter() {
      // return if invalid
      if (!this.validateForm()) return;
      this.loading = true;

      this.$nextTick(() => {
        const data = Object.assign({}, this.formData);
        data.termsConditions = data.termsConditions.toString();
        data.optinSubscription = data.optinSubscription.toString();

        this.$http.post('https://repopul8.circul8.com.au/api/save/', JSON.stringify(data))
          .then((response) => {
            // success
            if (response.body.status === 'ok') {
              console.log('success: ', response);
              this.$ga.event('SecretScrolls', 'Click', 'Submit');
              // this.$store.commit('setView', 'complete');
              this.$router.push({ path: 'complete' });
              window.scrollTo(0, 0);
            } else {
              console.log('error: ', response);
            }
          }, (response) => {
            // error
            console.log('error: ', response);
          })
          .then(() => {
            this.loading = false;
          });
      });
    },
    getParameterByName(name, url) {
      const currentUrl = url || window.location.href;
      const regex = new RegExp(`[?&]${name.replace(/[[\]]/g, '\\$&')}(=([^&#]*)|&|#|$)`);
      const results = regex.exec(currentUrl);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
  },
  mounted() {
    this.formData.utm_source = this.getParameterByName('utm_source');
    this.formData.utm_campaign = this.getParameterByName('utm_campaign');
    this.formData.utm_medium = this.getParameterByName('utm_medium');
  },
};
</script>



// WEBPACK FOOTER //
// EntryForm.vue?7789f793